import { Component, Inject } from '@angular/core';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material';
import { formatDateFr } from '../ordonnance-pdf';
import { Ordonnance } from '../../../../../models/ordonnance';
import { OrdonnancePartageService } from '../ordonnance-partage.service';

export interface PartageOrdonnanceSheetData {
	ordonnance: Ordonnance;
	avecCachet: boolean;
	avecEntite: boolean;
}

/**
 * Feuille du bas (MatBottomSheet) : version téléphone du menu « Partager l'ordonnance ». Remplace, sur mobile,
 * le panneau `position: fixed` maison de OrdenanceComponent, qui pouvait s'afficher loin en dessous de l'écran
 * visible sur iOS Safari lorsque la liste d'ordonnances est longue (obligeant à tout faire défiler pour le
 * voir — retour du client du 2026-09-23). MatBottomSheet s'appuie sur le CDK Overlay d'Angular Material, qui
 * gère ce cas correctement (même mécanisme que mat-menu/mat-dialog, déjà utilisés ailleurs dans l'application).
 * Sur ordinateur, le menu ancré personnalisé (`OrdenanceComponent`) reste utilisé tel quel.
 */
@Component({
	selector: 'kt-partage-ordonnance-sheet',
	templateUrl: './partage-ordonnance-sheet.component.html',
	styleUrls: ['./partage-ordonnance-sheet.component.scss'],
})
export class PartageOrdonnanceSheetComponent {
	readonly formatDate = formatDateFr;

	constructor(
		private sheetRef: MatBottomSheetRef<PartageOrdonnanceSheetComponent>,
		private partageService: OrdonnancePartageService,
		@Inject(MAT_BOTTOM_SHEET_DATA) public data: PartageOrdonnanceSheetData,
	) {}

	fermer() {
		this.sheetRef.dismiss();
	}

	partagerWhatsApp() {
		this.partageService.partagerWhatsApp(this.data.ordonnance, this.data.avecCachet, this.data.avecEntite);
		this.fermer();
	}

	partagerMessengerEmail() {
		this.partageService.partagerMessengerEmail(this.data.ordonnance, this.data.avecCachet, this.data.avecEntite);
		this.fermer();
	}

	partagerAutresApplications() {
		this.partageService.partagerAutresApplications(this.data.ordonnance, this.data.avecCachet, this.data.avecEntite);
		this.fermer();
	}

	partagerImprimerPdf() {
		this.partageService.partagerImprimerPdf(this.data.ordonnance, this.data.avecCachet, this.data.avecEntite);
		this.fermer();
	}
}
